import { render, staticRenderFns } from "./DataIntegrationTemplate.vue?vue&type=template&id=57734eff&lang=pug"
import script from "./DataIntegrationTemplate.vue?vue&type=script&lang=js"
export * from "./DataIntegrationTemplate.vue?vue&type=script&lang=js"
import style0 from "./DataIntegrationTemplate.vue?vue&type=style&index=0&id=57734eff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports